import styled from 'styled-components'
import Form from 'react-formal'
import { rem } from 'polished'
import typography from '../../../utils/typography'
import { media } from '../../../utils/style'
import { Flex, Box, Text, Heading } from 'rebass'
import assetIconArrowDown from '../../../vectors/icon-arrow-down.svg'
import assetIconArrowDownWhite from '../../../vectors/icon-arrow-down-white.svg'

/*************************
  STYLES: Form
**************************/
export const Fieldset = styled.fieldset`
  border: none;
  position: relative;
  z-index: 0;
  display: block;
  width: 100%;
  overflow: auto;
  ${media.LargeScreenUp`
  overflow: visible;
  `};
`

export const Field = styled(Form.Field)`
  position: relative;
  width: 100%;
  border: 2px ${(props) => props.theme.colors.grey_light_op65} solid;
  border-color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF' ? props.theme.colors.white : ''};
  background: ${(props) =>
    props.bg && props.bg !== '#FFFFFF' ? 'none' : props.theme.colors.white};
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white
      : props.theme.colors.grey};
  font-size: ${rem(15)};
  font-family: ${(props) => props.theme.font};
  padding-left: 15px;
  padding-right: 15px;
  transition: background 0.8s ${(props) => props.theme.ease.ease_out_expo};
  &::placeholder {
    color: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white
        : props.theme.colors.grey};
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
  }

  &:focus {
    outline: none;
    background: ${(props) =>
      props.bg && props.bg !== '#FFFFFF' ? 'none' : props.theme.colors.white};
    border-color: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white
        : props.theme.colors.blue};
    &::placeholder {
      font-weight: 400;
    }
  }

  &:hover {
    &::placeholder {
      color: ${(props) =>
        props.bg && props.bg !== '#FFFFFF'
          ? props.theme.colors.white
          : props.theme.colors.grey};
    }
  }

  &.invalid-field {
    border-color: ${(props) => props.theme.colors.orange};
  }
`

export const Input = styled(Field)`
  height: ${typography.rhythm(1.4)};
`

export const Select = styled(Field)`
  padding: 0;
`

export const TextArea = styled(Field)`
  position: relative;
  vertical-align: bottom;
  resize: none;
`

export const SubmitButton = styled(Form.Button)`
  cursor: pointer;
  font-family: ${(props) => props.theme.font};
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  background: none;
  outline: none;
  border-radius: 30px;
  z-index: 2;
  height: ${typography.rhythm(1.4)};
  padding: 0 14px;
  min-width: 100%;
  border: 3px solid currentColor;
  ${media.LargeScreenUp`
  margin-right: 20px;
  padding: 0 5%;
  min-width: 30%;
  `};
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white
      : props.theme.colors.blue};
  transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo},
    border-color 0.3s ${(props) => props.theme.ease.ease_out_expo};
  &:hover {
    color: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white_op65
        : props.theme.colors.grey_op90};
  }
`

/*************************
  STYLES: Feedback
**************************/
export const Message = styled(Form.Message)`
  font-weight: 600;
  line-height: 1.5;
  margin-top: 5px;
  margin-bottom: 8px;
  display: block;
`

export const ErrorText = styled(Text)`
  color: white;
  font-weight: 600;
  position: absolute;
  bottom: -${typography.rhythm(0.25)};
  left: 0;
  transform: translateY(100%);
`

export const Label = styled.label`
  font-weight: bold;
  display: block;
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white
      : props.theme.colors.grey_light};
  a {
    color: inherit;
  }
`

export const Widget = styled.div`
  .rw-widget-picker .rw-btn.rw-btn-select {
    position: relative;
  }
  .rw-dropdown-list .rw-btn.rw-btn-select::after {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    right: 17px;
    background: url(${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? assetIconArrowDownWhite
        : assetIconArrowDown})
      center no-repeat;
    transform: translateY(-50%) scale(1.5, 1.5);
    transform-origin: center;
  }
  .rw-dropdown-list.rw-open .rw-btn.rw-btn-select::after {
    transform: translateY(-70%) scale(-1.5, -1.5);
  }
  .rw-dropdown-list .rw-popup {
    border: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
    border-top: 0;
  }
  li {
    margin-bottom: 0;
  }
  /* stylelint-disable */
  .rw-btn,
  .rw-input-reset,
  .rw-input,
  .rw-filter-input {
    color: inherit;
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    background: none;
    background-image: none;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }
  .rw-btn::-moz-focus-inner {
    padding: 0;
    border: 0;
  }
  select.rw-input {
    text-transform: none;
  }
  html input[type='button'].rw-input {
    -webkit-appearance: button;
    cursor: pointer;
  }
  textarea.rw-input {
    overflow: auto;
    resize: vertical;
  }
  button[disabled].rw-input,
  fieldset[disabled] .rw-input,
  html input[disabled].rw-input {
    cursor: not-allowed;
  }
  button.rw-input::-moz-focus-inner,
  input.rw-input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  .rw-btn {
    position: relative;
    color: #7c86a2;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    cursor: pointer;
    outline: none;
  }
  .rw-state-readonly .rw-btn,
  .rw-state-disabled .rw-btn {
    cursor: not-allowed;
  }
  .rw-btn-select {
    opacity: 0.75;
    filter: alpha(opacity=75);
    transition: opacity 150ms ease-in;
  }
  .rw-btn-select:hover,
  .rw-state-focus .rw-btn-select,
  :hover > .rw-btn-select {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  .rw-btn-primary {
    width: 100%;
    white-space: normal;
    line-height: 2em;
  }
  .rw-btn-select[disabled],
  .rw-btn-primary[disabled],
  fieldset[disabled] .rw-btn-select,
  fieldset[disabled] .rw-btn-primary {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.65;
    filter: alpha(opacity=65);
    pointer-events: none;
  }
  .rw-sr {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .rw-widget {
    background-clip: border-box;
    border: none;
    color: #333;
    font-size: 1em;
    font-family: inherit;
    outline: none;
    position: relative;
  }
  .rw-widget,
  .rw-widget * {
    box-sizing: border-box;
  }
  .rw-widget:before,
  .rw-widget *:before,
  .rw-widget:after,
  .rw-widget *:after {
    box-sizing: border-box;
  }
  .rw-widget > .rw-widget-container {
    width: 100%;
    margin: 0;
  }

  .rw-widget-container {
    border: 2px solid
      ${(props) =>
        props.bg
          ? props.theme.colors.white
          : props.theme.colors.grey_light_op65};
    background: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white_op10
        : props.theme.colors.white_op30};
  }

  .rw-widget-container.rw-state-focus,
  .rw-state-focus > .rw-widget-container,
  .rw-widget-container.rw-state-focus:hover,
  .rw-state-focus > .rw-widget-container:hover {
    border-color: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white
        : props.theme.colors.blue};
  }

  .rw-widget-container.rw-state-readonly,
  .rw-state-readonly > .rw-widget-container {
    cursor: not-allowed;
  }
  .rw-widget-container.rw-state-disabled,
  .rw-state-disabled > .rw-widget-container,
  fieldset[disabled] .rw-widget-container,
  .rw-widget-container.rw-state-disabled:hover,
  .rw-state-disabled > .rw-widget-container:hover,
  fieldset[disabled] .rw-widget-container:hover,
  .rw-widget-container.rw-state-disabled:active,
  .rw-state-disabled > .rw-widget-container:active,
  fieldset[disabled] .rw-widget-container:active {
    box-shadow: none;
    cursor: not-allowed;
  }
  .rw-widget-picker {
    position: relative;
    overflow: hidden;
    border-collapse: separate;
    display: inline-table;
    height: 2.429em;
  }
  .rw-widget-picker > * {
    position: relative;
    border: none;
    outline: none;
    width: 100%;
    display: table-cell;
  }
  .rw-widget-picker > .rw-select {
    width: 1%;
    white-space: nowrap;
  }
  .rw-open > .rw-widget-picker {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rw-open-up > .rw-widget-picker {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  fieldset[disabled] .rw-widget-picker,
  .rw-state-disabled > .rw-widget-picker {
    background-color: #eee;
  }
  .rw-select {
    cursor: pointer;
  }
  .rw-select > * {
    width: 58px;
    height: 100%;
  }
  .rw-state-readonly .rw-select,
  .rw-state-disabled .rw-select {
    cursor: not-allowed;
  }
  .rw-state-disabled .rw-select-bordered,
  .rw-state-readonly .rw-select-bordered,
  fieldset[disabled] .rw-select-bordered,
  .rw-state-disabled .rw-select-bordered:hover,
  .rw-state-readonly .rw-select-bordered:hover,
  fieldset[disabled] .rw-select-bordered:hover,
  .rw-state-disabled .rw-select-bordered:active,
  .rw-state-readonly .rw-select-bordered:active,
  fieldset[disabled] .rw-select-bordered:active {
    cursor: not-allowed;
    background-color: inherit;
    background-image: none;
    box-shadow: none;
  }
  .rw-rtl .rw-select-bordered {
    border-right: #ccc 1px solid;
    border-left: none;
  }
  .rw-rtl {
    direction: rtl;
  }
  .rw-input-reset,
  .rw-input,
  .rw-filter-input {
    outline: 0;
  }
  .rw-input-reset::-moz-placeholder {
    color: #999;
    opacity: 1;
  }
  .rw-input-reset:-ms-input-placeholder {
    color: #999;
  }
  .rw-input-reset::-webkit-input-placeholder {
    color: #999;
  }
  .rw-input,
  .rw-filter-input {
    color: #555;
    padding: 7px 0.857em;
    background-color: #fff;
  }
  .rw-input[type='text']::-ms-clear {
    display: none;
  }
  .rw-input[disabled],
  fieldset[disabled] .rw-input {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
    background-color: #eee;
    border-color: #ccc;
  }
  .rw-input[readonly] {
    cursor: not-allowed;
  }

  .rw-placeholder {
    color: ${(props) =>
      props.bg && props.bg !== '#FFFFFF'
        ? props.theme.colors.white
        : props.theme.colors.grey};
  }

  .rw-widget-input,
  .rw-filter-input {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  }
  .rw-widget-input.rw-state-focus {
    background-color: red;
  }
  .rw-list {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 1em;
    outline: 0;
    overflow: auto;
    max-height: 200px;
  }
  .rw-list-option {
    -ms-user-select: none;
    user-select: none;
    color: #333;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 0 20px;
  }
  .rw-list-option.rw-state-focus,
  .rw-list-option.rw-state-focus:hover {
    background-color: transparent;
    border: #66afe9 1px solid;
    color: #333;
  }
  .rw-list-option:hover,
  .rw-list-option:hover.rw-state-focus {
    background-color: #e6e6e6;
    border: #e6e6e6 1px solid;
    color: #333;
  }
  .rw-list-option.rw-state-selected,
  .rw-list-option.rw-state-selected:hover {
    background-color: ${(props) => props.theme.colors.blue};
    border: ${(props) => props.theme.colors.blue} 1px solid;
    color: white;
  }
  fieldset[disabled] .rw-list-option,
  .rw-list-option.rw-state-disabled,
  .rw-list-option.rw-state-readonly {
    box-shadow: none;
    cursor: not-allowed;
    color: #999;
    filter: alpha(opacity=7);
    opacity: 0.7;
  }
  fieldset[disabled] .rw-list-option:hover,
  .rw-list-option.rw-state-disabled:hover,
  .rw-list-option.rw-state-readonly:hover {
    background: none;
    border-color: transparent;
  }
  .rw-list-empty,
  .rw-list-option,
  .rw-list-optgroup {
    padding: 0.143em 0.75em;
    outline: 0;
  }
  .rw-list-optgroup {
    font-weight: bold;
    padding-top: 7px;
  }
  .rw-list-option-create {
    border-top: 1px #ccc solid;
  }
  .rw-dropdown-list-input {
    background-color: transparent;
    vertical-align: middle;
    padding-right: 0;
    max-width: 1px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .rw-rtl .rw-dropdown-list-input {
    padding-right: 0.857em;
    padding-left: 0;
  }
  .rw-filter-input {
    position: relative;
    margin: 4px;
    padding-right: 0;
  }
  .rw-filter-input .rw-rtl {
    padding-right: 0.857em;
    padding-left: 0;
  }
  .rw-filter-input .rw-select,
  .rw-filter-input .rw-btn {
    opacity: 0.75;
    filter: alpha(opacity=75);
    cursor: text;
  }
  .rw-filter-input > .rw-select,
  .rw-filter-input > .rw-select:active,
  .rw-filter-input > .rw-select:hover {
    background: none;
    cursor: auto;
    box-shadow: none;
  }
  .rw-number-picker .rw-btn {
    cursor: pointer;
    height: calc(1.2145em - 1px);
    margin-top: -1px\9;
    height: 1.2145em\9;
    line-height: 1.2145em;
    line-height: calc(1.2145em - 1px);
    display: block;
    border: none;
  }
  .rw-number-picker .rw-btn:hover,
  .rw-number-picker .rw-btn:active {
    background-color: #e6e6e6;
  }
  .rw-number-picker .rw-btn:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  }
  .rw-state-disabled .rw-number-picker .rw-btn,
  .rw-state-readonly .rw-number-picker .rw-btn,
  fieldset[disabled] .rw-number-picker .rw-btn,
  .rw-state-disabled .rw-number-picker .rw-btn:hover,
  .rw-state-readonly .rw-number-picker .rw-btn:hover,
  fieldset[disabled] .rw-number-picker .rw-btn:hover,
  .rw-state-disabled .rw-number-picker .rw-btn:active,
  .rw-state-readonly .rw-number-picker .rw-btn:active,
  fieldset[disabled] .rw-number-picker .rw-btn:active {
    cursor: not-allowed;
    background-color: inherit;
    background-image: none;
    box-shadow: none;
  }
  .rw-number-picker .rw-select {
    vertical-align: middle;
  }
  .rw-number-picker .rw-select,
  .rw-number-picker .rw-select:hover,
  .rw-number-picker .rw-select:active {
    box-shadow: none;
  }
  .rw-cell {
    color: #7c86a2;
    cursor: pointer;
    line-height: normal;
    font-size: 14px;
    text-align: center;
    border: 1px solid transparent;
    padding: 0.25em;
  }
  .rw-cell:hover {
    background-color: #e6e6e6;
    border: #e6e6e6 1px solid;
    color: #333;
  }
  .rw-cell.rw-state-focus,
  .rw-cell.rw-state-focus:hover {
    background-color: transparent;
    border: #66afe9 1px solid;
    color: #333;
  }
  .rw-cell.rw-state-selected,
  .rw-cell.rw-state-selected:hover {
    background-color: ${(props) => props.theme.colors.blue};
    border: ${(props) => props.theme.colors.blue} 1px solid;
    color: white;
    font-weight: bold;
  }
  .rw-cell.rw-state-disabled {
    color: #e1e4e7;
  }
  .rw-cell.rw-state-disabled:hover {
    background: none;
    border-color: transparent;
  }
  .rw-calendar-month .rw-cell {
    text-align: center;
  }
  .rw-cell-off-range {
    color: #7c86a2;
    opacity: 0.55;
  }
  .rw-select-list {
    overflow: auto;
  }
  .rw-select-list .rw-list {
    max-height: none;
    font-size: 1em;
  }
  .rw-select-list-label {
    display: block;
    position: relative;
    font-weight: normal;
    cursor: inherit;
    padding-left: 20px;
    margin: 0;
  }
  .rw-rtl .rw-select-list-label {
    padding-left: 0;
    padding-right: 20px;
  }
  input.rw-select-list-input {
    position: absolute;
    left: 0;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    top: 0.1em /9;
    margin: 0;
    line-height: normal;
    cursor: inherit;
  }
  .rw-rtl input.rw-select-list-input {
    left: auto;
    right: 0;
  }
  .rw-autocomplete .rw-select {
    position: absolute;
    display: block;
    width: auto;
    top: 0;
    bottom: 0;
    right: 0;
  }
  .rw-popup-container {
    position: absolute;
    z-index: 1005;
    top: 100%;
    left: -6px;
    right: -6px;
  }
  .rw-popup-container.rw-dropup {
    top: auto;
    bottom: -1px;
  }
  .rw-state-focus .rw-popup-container {
    z-index: 1006;
  }
  .rw-popup-transition {
    width: 100%;
    margin-bottom: 6px;
    padding: 0 6px;
  }
  .rw-dropup > .rw-popup-transition {
    margin-bottom: 0;
    margin-top: 6px;
  }
  .rw-popup {
    border: none;
    background: #fff;
  }
  .rw-popup-transition {
    transition: transform 200ms;
  }
  .rw-popup-transition-entering {
    overflow: hidden;
  }
  .rw-popup-transition-entering .rw-popup-transition {
    -ms-transform: translateY(0);
    transform: translateY(0);
    transition-timing-function: ease-out;
  }
  .rw-popup-transition-exiting .rw-popup-transition {
    transition-timing-function: ease-in;
  }
  .rw-popup-transition-exiting,
  .rw-popup-transition-exited {
    overflow: hidden;
  }
  .rw-popup-transition-exiting .rw-popup-transition,
  .rw-popup-transition-exited .rw-popup-transition {
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
  }
  .rw-popup-transition-exiting.rw-dropup .rw-popup-transition,
  .rw-popup-transition-exited.rw-dropup .rw-popup-transition {
    -ms-transform: translateY(100%);
    transform: translateY(100%);
  }
  .rw-popup-transition-exited {
    display: none;
  }
  .rw-state-disabled {
    box-shadow: none;
    cursor: not-allowed;
  }
  /* stylelint-enable */

  .rw-input {
    &::placeholder {
      color: ${(props) => props.theme.colors.grey_op80};
      transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    }

    &:focus {
      outline: none;
      background: white;
      border-color: ${(props) => props.theme.colors.blue};
      &::placeholder {
        font-weight: 400;
      }
    }

    &:hover {
      &::placeholder {
        color: ${(props) => props.theme.colors.grey};
      }
    }
  }
  .invalid-field .rw-widget-container {
    border-color: ${(props) => props.theme.colors.orange};
  }
`

export const SectionTitle = styled(Heading)`
  margin-bottom: ${typography.rhythm(0.5)};
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white
      : props.theme.colors.blue};
  ${media.LargeScreenUp`
  margin-bottom: ${typography.rhythm(1)};
  `};
`

export const SectionHeading = styled(Box)`
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.weights[1]};
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white_op65
      : props.theme.colors.grey_light};
`

export const FlexWrapper = styled(Flex)`
  max-width: ${(props) => props.theme.content.max.width};
`
FlexWrapper.defaultProps = {
  mx: 'auto'
}

export const Background = styled(Box)`
  background-color: ${(props) =>
    props.bg ? props.bg : props.theme.colors.blue_light};
  min-width: 100%;
  color: ${(props) =>
    props.bg && props.bg !== '#FFFFFF'
      ? props.theme.colors.white
      : props.theme.colors.grey_light};
`
